export default "__VITE_ASSET__cf392d6f__"